export const lagecyauth0Cred = {
    "domain": "login.agingoptions.com",
    "clientID": "FAxHNQMLuCSwVC1upmi102fnmdilj2OF",
    "realm": "Username-Password-Authentication",
    "responseType": "token id_token",
    "redirectUri": "https://lpo.agingoptions.com/",
    "scope": "openid profile email offline_access"
  }
  
  